import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CreateNewCVPCandidateParametersSimple } from "./CreateNewCVPCandidateParametersSimple";

export interface CreateProfileResponse extends BackendResponse {}

export interface CreateProfileParameters
  extends NextApiParams,
    CreateNewCVPCandidateParametersSimple {}

export const createProfile = withNextApi<
  CreateProfileResponse,
  CreateProfileParameters
>("/auth/CreateProfile");
